import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteContent, galleryImages, bapuImage } from '../data/mock';
import { X, ZoomIn } from 'lucide-react';

const GallerySection = () => {
  const { language } = useLanguage();
  const content = siteContent[language].gallery;
  const [selectedImage, setSelectedImage] = useState(null);

  // Create a gallery with the main image repeated in different styles for visual variety
  const displayImages = [
    { id: 1, src: bapuImage, alt: galleryImages[0].alt },
    { id: 2, src: bapuImage, alt: galleryImages[0].alt },
    { id: 3, src: bapuImage, alt: galleryImages[0].alt },
    { id: 4, src: bapuImage, alt: galleryImages[0].alt },
  ];

  return (
    <section id="gallery" className="py-16 md:py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-orange-800 mb-4">
            {content.title}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-600 max-w-2xl mx-auto">
            {content.subtitle}
          </p>
          <div className="mt-6 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-orange-400 to-amber-400 rounded-full" />
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {displayImages.map((image, index) => (
            <div
              key={image.id}
              className={`group relative cursor-pointer overflow-hidden rounded-xl md:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 ${
                index === 0 ? 'col-span-2 row-span-2' : ''
              }`}
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.src}
                alt={image.alt[language === 'gu' ? 'gu' : 'en']}
                className={`w-full object-cover transition-transform duration-500 group-hover:scale-110 ${
                  index === 0 ? 'h-48 sm:h-64 md:h-full' : 'h-32 sm:h-40 md:h-56'
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-orange-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <ZoomIn className="w-5 h-5 md:w-6 md:h-6 text-white" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note about gallery */}
        <p className="text-center text-gray-500 mt-6 md:mt-8 text-xs md:text-sm">
          {language === 'gu' 
            ? 'વધુ ફોટા ટૂંક સમયમાં ઉમેરવામાં આવશે' 
            : 'More photos will be added soon'}
        </p>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 w-10 h-10 md:w-12 md:h-12 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-5 h-5 md:w-6 md:h-6" />
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt[language === 'gu' ? 'gu' : 'en']}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default GallerySection;
